"use client";
import { Box } from "@chakra-ui/react";
import { useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Text } from "@/elements";
import CardsList from "@/components/cardsList";

const Connection = (props) => {
  const TextVariant = useTextVariant();
  return (
    <Box maxW={"5xl"} mx="auto">
      <CardsList {...props} columns={{ base: 1, sm: 2 }} />
      <Text variant={TextVariant} color="text.100" textAlign="center" my={8}>
        {props.conclusion}
      </Text>
    </Box>
  );
};

export default Connection;
